export default "__VITE_ASSET__5ca5fb92__"